import { Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../reducers/userSlice";
import { loadFBA, selectFBA } from "../../reducers/fbaSlice";
import { selectRTFO } from "../../reducers/rtfoSlice";
import { FBASummarySection } from "../fba/FBASummarySection";
import { FBASummaryChart } from "../fba/FBASummaryChart";
import { FBASummaryDataTable } from "../fba/FBASummaryDataTable";

export const RTFOFBA = ({ currentWellName }) => {

  const theme = useTheme();
  const user = useSelector(selectUser);
  const darkMode = user?.value?.darkMode;
  const dispatch = useDispatch();
  const fba = useSelector(selectFBA);
  const rtfo = useSelector(selectRTFO);
  const currentRTFO = rtfo?.value;
  
  const fbaLink = currentRTFO?.fbas?.wells?.[currentWellName?.toLowerCase()];
  const startIndex = fbaLink?.lastIndexOf("/") + 1;
  const endIndex = fbaLink?.lastIndexOf(".json");
  const fbaId = fbaLink?.substring(startIndex, endIndex);
  let currentFBA = fba?.byId?.[fbaId];

  useEffect(() => {
    if (!currentFBA && fbaId && fbaLink) {
      console.log('Loading FBA...');
      dispatch(loadFBA({ fbaId, location: fbaLink, keepId: true }));
    };
  }, [currentFBA, dispatch, fbaId, fbaLink]);

  return (
    <Paper style={{display: 'flex', margin: '0 20px', position: 'relative', flexDirection: 'column', padding: 4, backgroundColor: (theme?.palette?.elevationOne?.[(darkMode ? 'dark' : 'light')])}} elevation={0} sx={{boxShadow: 1}}>

      {currentFBA ? 
        <div style={{margin: 20}}>
          <Typography variant="h6">FBA Summary</Typography>
          <Typography style={{fontSize: '16px'}}>{currentWellName} Well</Typography>
          <FBASummarySection fba={currentFBA} />
          <FBASummaryChart fba={currentFBA} />
          <FBASummaryDataTable fba={currentFBA} blur={true} />

        </div> :
        <div style={{height: 540, width: '100%', margin: 20, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Typography style={{marginBottom: 10}}>No FBA loaded</Typography>
        </div>
      }


    </Paper>
  )

};